import React from 'react'
import cn from 'classnames'
import { observer } from 'mobx-react'

import SuperDiv from 'components/superDiv/SuperDiv'
import TypeIcon from 'components/typeIcon/TypeIcon'
import Spinner from 'components/spinner/Spinner'

import PlayIcon from 'assets/icons/play.svg'

import treeStringify from 'utils/treeStringify'

import styles from './treeRowArray.scss'

interface IProps {
  path: string
  isSelected: boolean
  isExpanded: boolean
  startIndex: number
  endIndex: number
  value: any
  isLoading: boolean
  style: React.CSSProperties
  onToggleCollapse: (path: string) => void
}

class TreeRowArraySlice extends React.PureComponent<IProps> {
  handleToggleCollapse = (e: React.FormEvent<HTMLDivElement>) => {
    const { path, isLoading, onToggleCollapse } = this.props

    e.stopPropagation()

    if (isLoading) {
      return
    }

    onToggleCollapse(path)
  }

  handleExpand = (e: React.FormEvent<HTMLDivElement>) => {
    const { isExpanded } = this.props

    if (!isExpanded) {
      this.handleToggleCollapse(e)
    }
  }

  render() {
    const {
      path,
      isSelected,
      isExpanded,
      startIndex,
      endIndex,
      value,
      isLoading,
      style,
    } = this.props

    const depth = path.split('::').length - 1

    return (
      <div
        tabIndex={1}
        data-cy="tree__array"
        className={cn(styles.container, {
          [styles.expanded]: isExpanded,
          [styles.active]: !isExpanded && isSelected,
        })}
        style={style}
      >
        <div className={styles.depthGutter} style={{ width: depth * 16 }}></div>

        <div data-cy="expand-btn" className={styles.expandButton}>
          {isLoading ? (
            <Spinner size={3} className={styles.loader} />
          ) : (
            <PlayIcon />
          )}
        </div>

        <div
          className={cn(styles.meta, {
            [styles.active]: isExpanded && isSelected,
          })}
          onClick={this.handleToggleCollapse}
        >
          <TypeIcon className={styles.icon} array required />
          <div className={styles.fieldName}>
            {`[${startIndex}-${endIndex}]:`}
          </div>
        </div>

        <SuperDiv
          className={styles.fieldValue}
          onClickButNotDrag={this.handleExpand}
        >
          <>
            {`(${value && value.length}) `}
            {treeStringify(value, { maxLength: 150 })}
          </>
        </SuperDiv>
      </div>
    )
  }
}

export default observer(TreeRowArraySlice)
